/**
 * Compose a display string from the three Person.Birthdate columns the
 * BE returns. Returns null if any part is missing — the BE may persist
 * partial birthdates depending on the source application.
 */
export function formatBirthDate(
  day: number | null,
  month: number | null,
  year: number | null,
  locale: string,
): string | null {
  if (!day || !month || !year) return null;
  try {
    const date = new Date(Date.UTC(year, month - 1, day));
    return new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: 'UTC',
    }).format(date);
  } catch {
    return `${pad(day)}.${pad(month)}.${year}`;
  }
}

function pad(n: number): string {
  return n.toString().padStart(2, '0');
}
